import { Base } from '../../../../../common/models';
import { DEFAULT_PAGE_SIZE_OPTIONS, ListQueryParam } from '../../../../../common/constants';
import { TransportManagementFiltersInputModel } from './transport-management-filters.model';

export class TransportManagementSearchCriteria extends TransportManagementFiltersInputModel {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE_OPTIONS[1];
  [ListQueryParam.Page] = 0;
  id?: number;
  name?: string;
  constructor(params?: TransportManagementSearchCriteria | Base) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
